import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import Select from "react-select";
import MessageCard from "../../../components/AdminCards/MessageCard";

function AddExpensesCategoryForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    vat_percentage: "",
    tax_method: "",
    description: "",
    user_id: user.user.id,
    outlet_id: user.user.outlet_id,
  });
  const [pageLoading, setPageLoading] = useState(false);
  const chooseOptions = [
    {
      value: "No Tax",
      label: "No Tax",
    },
    {
      value: "Inclusive",
      label: "Inclusive",
    },
    {
      value: "Exclusive",
      label: "Exclusive",
    },
  ];
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/expensescategory`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .put(`${apiKey}/api/rms/admin/expensescategory/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      }
    };
    handleCSRF(postData);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      const fetchExpenseCat = () => {
        axios
          .get(`${apiKey}/api/rms/admin/expensescategory/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            setFormData(res.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => setPageLoading(false));
      };
      handleCSRF(fetchExpenseCat);
    }
  }, [id, user?.token]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl"> Add Expenses</h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Expense Category Name
                </span>
                <div className="mb-2 pt-0">
                  {/* <input
                    type="text"
                    placeholder="Expense Category Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                   required 
                   value={formData.name}
                    onChange={handleChange}/> */}
                  <input
                    type="text"
                    placeholder="Expense Category Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    name="name"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Expense Item Vat i.e (5,10,15 ..)
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Expense Item Vat i.e (5,10,15 ..) "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    value={formData.vat_percentage}
                    onChange={handleChange}
                    name="vat_percentage"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Tax method
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder="Select"
                    defaultValue={{
                      value: formData.tax_method,
                      label: formData.tax_method,
                    }}
                    options={chooseOptions}
                    onChange={(e) =>
                      setFormData({ ...formData, tax_method: e.value })
                    }
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Description"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    value={formData.description}
                    onChange={handleChange}
                    name="description"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddExpensesCategoryForm;
